import Vue from "vue";
import Router from "vue-router";
import store from "./../vuex/store";

Vue.use(Router);

const rejectFunc = () => {
  store.commit("UPDATE_LOADING", false);
  store.commit("SHOWTOAST", "服务器异常");
};

export default new Router({
  routes: [
    {
      path: "/",
      component: function(resolve) {
        require(["../page/home.vue"], resolve, rejectFunc);
      }
    },
    //登录
    {
      path: "/login",
      component: function(resolve) {
        require(["../page/login.vue"], resolve, rejectFunc);
      }
    },

    //注册
    {
      path: "/register",
      component: function(resolve) {
        require(["../page/register.vue"], resolve, rejectFunc);
      }
      /*meta: {
        keepAlive: true // 需要被缓存
      }*/
    },
    // //注册协议
    // {
    //   path: '/registerContract',
    //   component: function (resolve) {
    //     require(['../page/registerContract.vue'], resolve, rejectFunc)
    //   }
    // },
    //找回密码
    {
      path: "/forgetPass",
      component: function(resolve) {
        require(["../page/forgetPass.vue"], resolve, rejectFunc);
      }
    },
    //忘记交易密码--请输入验证码
    {
      path: "/indentifyingCode",
      component: function(resolve) {
        require(["../page/indentifyingCode.vue"], resolve, rejectFunc);
      }
    },
    //忘记交易密码--设置交易密码
    {
      path: "/setDealPassWord",
      component: function(resolve) {
        require(["../page/setDealPassWord.vue"], resolve, rejectFunc);
      }
    },
    //首页
    {
      path: "/home",
      component: function(resolve) {
        require(["../page/home.vue"], resolve, rejectFunc);
      }
    },
    //产品列表
    {
      path: "/productList",
      component: function(resolve) {
        require(["../page/productList.vue"], resolve, rejectFunc);
      }
    },    
    //保理详情页
    {
      path: "/productDetail",
      component: function(resolve) {
        require(["../page/productDetail.vue"], resolve, rejectFunc);
      }
    },
    //首页产品列表 》 产品详情页
    {
      path: "/home-product-detail",
      component: function(resolve) {
        require(["../page/home_product_detail.vue"], resolve, rejectFunc);
      }
    },

    //借款申请  步骤1
    {
      path: "/loan-application",
      component: function(resolve) {
        require(["../page/loan_application.vue"], resolve, rejectFunc);
      },
      meta: {
        //keepAlive: true // 需要被缓存
      }
    },
    //借款信息确认 步骤2
    {
      path: "/confirmLoanInfo",
      component: function(resolve) {
        require(["../page/confirmLoanInfo.vue"], resolve, rejectFunc);
      }
    },

    //申请提交成功 步骤3
    {
      path: "/loanApplayForSuccess",
      component: function(resolve) {
        require(["../page/loanApplayForSuccess.vue"], resolve, rejectFunc);
      }
    },

    //还款
    {
      path: "/repayment",
      component: function(resolve) {
        require(["../page/repayment.vue"], resolve, rejectFunc);
      }
    },

    //还款记录（我的）
    {
      path: "/myRepayment",
      component: function(resolve) {
        require(["../page/myRepayment.vue"], resolve, rejectFunc);
      }
    },
    //我的--已结清页面
    {
      path: "/my-settle",
      component: function(resolve) {
        require(["../page/mySettle.vue"], resolve, rejectFunc);
      }
    },
    //还款--还款详情
    {
      path: "/repaymentDetail",
      component: function(resolve) {
        require(["../page/repaymentDetail.vue"], resolve, rejectFunc);
      }
    },
    //还款--还款详情--已还款
    {
      path: "/repayFinishDetail",
      component: function(resolve) {
        require(["../page/repayFinishDetail.vue"], resolve, rejectFunc);
      }
    },
    //还款--提前还款
    {
      path: "/prepayment",
      component: function(resolve) {
        require(["../page/prepayment.vue"], resolve, rejectFunc);
      }
    },
    //还款--还款结果详情
    {
      path: "/repayResult",
      component: function(resolve) {
        require(["../page/repayResult.vue"], resolve, rejectFunc);
      }
    },
    //我的
    {
      path: "/me",
      component: function(resolve) {
        require(["../page/me.vue"], resolve, rejectFunc);
      }
    },
    //我的借款申请
    {
      path: "/myLoanApplyList",
      component: function(resolve) {
        require(["../page/myLoanApplyList.vue"], resolve, rejectFunc);
      }
    },

    //我的借款详情
    {
      path: "/myLoanApplyDetail/:id",
      component: function(resolve) {
        require(["../page/myLoanApplyDetail.vue"], resolve, rejectFunc);
      }
    },

    //我的银行卡
    {
      path: "/myBankCardList",
      component: function(resolve) {
        require(["../page/myBankCardList.vue"], resolve, rejectFunc);
      }
    },
    //添加银行卡-->实名认证
    {
      path: "/addBankCard",
      component: function(resolve) {
        require(["../page/addBankCard.vue"], resolve, rejectFunc);
      }
    },

    //添加银行卡--列表添加
    {
      path: "/addBankCard2",
      component: function(resolve) {
        require(["../page/addBankCard2.vue"], resolve, rejectFunc);
      }
    },

    //银行卡签约
    {
      path: "/bankCardSign",
      component: function(resolve) {
        require(["../page/bankCardSign.vue"], resolve, rejectFunc);
      }
    },
    //实名认证（步骤一）
    {
      path: "/realNameAuth",
      component: function(resolve) {
        require(["../page/realNameAuth.vue"], resolve, rejectFunc);
      },
      meta: {
        // keepAlive: true
      }
    },
    //获取额度（实名认证步骤二）
    {
      path: "/getCredits",
      component: function(resolve) {
        require(["../page/getCredits.vue"], resolve, rejectFunc);
      }
    },
    //授权中心
    {
      path: "/authorization_center",
      component: function(resolve) {
        require(["../page/authorization_center.vue"], resolve, rejectFunc);
      }
    },
    //账号设置
    {
      path: "/accountSetting",
      component: function(resolve) {
        require(["../page/accountSetting.vue"], resolve, rejectFunc);
      }
    },
    //重置密码
    {
      path: "/resetPass",
      component: function(resolve) {
        require(["../page/resetPass.vue"], resolve, rejectFunc);
      }
    },
    //更多
    {
      path: "/more",
      component: function(resolve) {
        require(["../page/more.vue"], resolve, rejectFunc);
      }
    },
    //更多--获取内容
    {
      path: "/getContent",
      component: function(resolve) {
        require(["../components/getContent.vue"], resolve, rejectFunc);
      }
    },
    //更多--我的投诉
    {
      path: "/my_complain",
      component: function(resolve) {
        require(["../page/my_complain.vue"], resolve, rejectFunc);
      }
    },
    //更多--我的投诉--提交投诉
    {
      path: "/complain",
      component: function(resolve) {
        require(["../page/complain.vue"], resolve, rejectFunc);
      }
    },
    //更多--我的投诉--投诉详情
    {
      path: "/complain_detail",
      component: function(resolve) {
        require(["../page/complain_detail.vue"], resolve, rejectFunc);
      }
    },
    // 更多--我的建议
    {
      path: "/my_suggest",
      component: function(resolve) {
        require(["../page/my_suggest.vue"], resolve, rejectFunc);
      }
    },
    // 更多--提交建议
    {
      path: "/add_suggest",
      component: function(resolve) {
        require(["../page/add_suggest.vue"], resolve, rejectFunc);
      }
    },
    // 更多--我的建议--建议详情
    {
      path: "/suggest_detail",
      component: function(resolve) {
        require(["../page/suggest_detail.vue"], resolve, rejectFunc);
      }
    },
    // 更多--我的工单
    {
      path: "/my_order",
      component: function(resolve) {
        require(["@/page/myOrder/my_order.vue"], resolve, rejectFunc);
      }
    },
    // 更多--我的工单-提交工单
    {
      path: "/add_order",
      component: function(resolve) {
        require(["@/page/myOrder/add_order.vue"], resolve, rejectFunc);
      }
    },
    // 更多--我的工单--工单详情
    {
      path: "/orderdetails",
      component: function(resolve) {
        require(["@/page/myOrder/orderdetails.vue"], resolve, rejectFunc);
      }
    },
    //更多--我的举报
    {
      path: "/my_report",
      component: function(resolve) {
        require(["../page/my_report.vue"], resolve, rejectFunc);
      }
    },
    //更多--我的举报--提交举报
    {
      path: "/add_report",
      component: function(resolve) {
        require(["../page/add_report.vue"], resolve, rejectFunc);
      }
    },
    //更多--我的举报--举报详情
    {
      path: "/report_detail",
      component: function(resolve) {
        require(["../page/report_detail.vue"], resolve, rejectFunc);
      }
    },
    //我的--企业认证
    {
      path: "/enterprise_certification",
      component: function(resolve) {
        require(["../page/enterprise/enterprise_certification.vue"], resolve, rejectFunc);
      }
    },
    // 测试我的--实名认证
    {
      path: "/realNameAuthentication",
      component: function(resolve) {
        require(["../page/realNameAuthentication/index.vue"], resolve, rejectFunc);
      }
    },
    // 测试我的--企业认证
    // {
    //   path: "/enterpriseIndex",
    //   component: function(resolve) {
    //     require(["../page/enterprise/index.vue"], resolve, rejectFunc);
    //   }
    // },
    //测试我的--企业附件上传
    // {
    //   path: "/attachmentUpload",
    //   component: function(resolve) {
    //     require(["../page/enterprise/attachmentUpload.vue"], resolve, rejectFunc);
    //   }
    // },
    //错误页面
    {
      path: "/nofind",
      component: function(resolve) {
        require(["../page/tip/nofind.vue"], resolve, rejectFunc);
      }
    },
    //错误页面
    {
      path: "*",
      component: function(resolve) {
        require(["../page/tip/nofind.vue"], resolve, rejectFunc);
      }
    },
    //融资申请流程
    {
      path: "/applicationProcess",
      component: function(resolve) {
        require(["../page/applicationProcess.vue"], resolve, rejectFunc);
      }
    },
    //融资申请流程2
    {
      path: "/informationEntry",
      name: "informationEntry",
      component: function(resolve) {
        require(["../page/informationEntry.vue"], resolve, rejectFunc);
      }
    },
    //查看融资信息
    {
      path: "/examine",
      name: "examine",
      component: function(resolve) {
        require(["../page/examine.vue"], resolve, rejectFunc);
      }
    },
    //添加融资信息
    {
      path: "/addinformation",
      name: "addinformation",
      // meta: { keepAlive: true }, // 需要被缓存
      component: function(resolve) {
        require(["../page/addinformation.vue"], resolve, rejectFunc);
      }
    },
    //修改融资信息
    {
      path: "/reviseinformation",
      name: "reviseinformation",
      component: function(resolve) {
        require(["../page/reviseinformation.vue"], resolve, rejectFunc);
      }
    },
    //我的银行卡
    {
      path: "/bankamericard",
      name: "bankamericard",
      component: function(resolve) {
        require(["../page/bankamericard.vue"], resolve, rejectFunc);
      }
    },
    //银行卡
    {
      path: "/bankcard",
      name: "bankcard",
      component: function(resolve) {
        require(["../page/bankcard.vue"], resolve, rejectFunc);
      }
    },
    //确认银行卡
    {
      path: "/confirmcard",
      name: "confirmcard",
      component: function(resolve) {
        require(["../page/confirmcard.vue"], resolve, rejectFunc);
      }
    },
    //资料附件
    {
      path: "/appendix",
      name: "appendix",
      component: function(resolve) {
        require(["../page/appendix.vue"], resolve, rejectFunc);
      }
    },
    //银行卡详情
    {
      path: "/carddetails",
      name: "carddetails",
      component: function(resolve) {
        require(["../page/carddetails.vue"], resolve, rejectFunc);
      }
    },
    //图片上传
    {
      path: "/imageunload",
      name: "imageunload",
      component: function(resolve) {
        require(["../page/imageunload.vue"], resolve, rejectFunc);
      }
    },
    //注册协议
    {
      path: "/agreement",
      name: "agreement",
      component: function(resolve) {
        require(["../page/agreement.vue"], resolve, rejectFunc);
      }
    },
    //银行卡绑定协议
    {
      path: "/protocol",
      name: "protocol",
      component: function(resolve) {
        require(["../page/protocol.vue"], resolve, rejectFunc);
      }
    },
    //我的保理
    {
      path: "/myBaoli",
      name: "myBaoli",
      component: function(resolve) {
        // require(["../page/myBaoli.vue"], resolve, rejectFunc);
        require(["../page/myBaoli/index.vue"], resolve, rejectFunc);
      }
    },
    //保理项目详情
    {
      path: "/borrowDetails",
      name: "borrowDetails",
      component: function(resolve) {
        require(["../page/borrowDetails.vue"], resolve, rejectFunc);
      }
    },
    //我的凭证管理
    {
      path: "/myVoucheManagement",
      name: "myVoucheManagement",
      component: function(resolve) {
        require(["../page/myVoucheManagement/index.vue"], resolve, rejectFunc);
        //require(["../page/myVoucheManagement.vue"], resolve, rejectFunc);
      }
    },
    //我的融资放款申请
    {
      path: "/loanPayList",
      name: "loanPayList",
      component: function(resolve) {
        require(["../page/loanPayList.vue"], resolve, rejectFunc);
      }
    },    
    //电子合同
    {
      path: "/contract",
      name: "contract",
      component: function(resolve) {
        require(["../page/contract.vue"], resolve, rejectFunc);
      }
    },
    //添加凭证
    {
      path: "/addVoucher",
      name: "addVoucher",
      component: function(resolve) {
        require(["../page/addVoucher.vue"], resolve, rejectFunc);
      }
    },
    //凭证图片上传
    {
      path: "/voucherImageunload",
      name: "voucherImageunload",
      component: function(resolve) {
        require(["../page/voucherImageunload.vue"], resolve, rejectFunc);
      }
    },
    //凭证修改
    {
      path: "/voucheExamine",
      name: "voucheExamine",
      component: function(resolve) {
        require(["../page/voucheExamine.vue"], resolve, rejectFunc);
      }
    },
    //个人信息
    {
      path: "/personalInformation",
      name: "personalInformation",
      component: function(resolve) {
        require(["../page/personalInformation.vue"], resolve, rejectFunc);
      }
    },
    //企业信息
    {
      path: "/enterprise",
      name: "enterprise",
      component: function(resolve) {
        require(["../page/enterprise.vue"], resolve, rejectFunc);
      }
    },
    //回购通知书
    {
      path: "/buybackNotice",
      name: "buybackNotice",
      component: function(resolve) {
        require(["../page/buybackNotice.vue"], resolve, rejectFunc);
      }
    },
    //回购通知书详情
    {
      path: "/checkBuyback",
      name: "checkBuyback",
      component: function(resolve) {
        require(["../page/checkBuyback.vue"], resolve, rejectFunc);
      }
    },
    // 转让通知书列表
    {
      path: "/transferAdviceList",
      name: "transferAdviceList",
      component: function(resolve) {
        require(["../page/transferAdviceList.vue"], resolve, rejectFunc);
      }
    },
    // 转让通知书详情
    {
      path: "/transferAdviceDetail",
      name: "transferAdviceDetail",
      component: function(resolve) {
        require(["../page/transferAdviceDetail.vue"], resolve, rejectFunc);
      }
    },
    //我的还款
    {
      path: "/backMoney",
      name: "backMoney",
      component: function(resolve) {
        require(["../page/backMoney.vue"], resolve, rejectFunc);
      }
    },
    //我的还款详情
    {
      path: "/backmoneyDetail",
      name: "backmoneyDetail",
      component: function(resolve) {
        require(["../page/backmoneyDetail.vue"], resolve, rejectFunc);
      }
    },
    //消息页面
    {
      path: "/message",
      name: "message",
      component: function(resolve) {
        require(["../page/message.vue"], resolve, rejectFunc);
      }
    },
    //消息详情页面
    {
      path: "/messagedetails",
      name: "messagedetails",
      component: function(resolve) {
        require(["../page/messagedetails.vue"], resolve, rejectFunc);
      }
    },
     //主页2
     {
      path: "/home2",
      name: "home2",
      component: function(resolve) {
        require(["../page/home2.vue"], resolve, rejectFunc);
      }
    },
    //项目合同列表
    {
      path: "/projectContractList",
      name: "projectContractList",
      component: function(resolve) {
        require(["../page/projectContractList.vue"], resolve, rejectFunc);
      }
    },  
    //保理主合同列表
    {
      path: "/mainProjectContractList",
      name: "mainProjectContractList",
      component: function(resolve) {
        require(["../page/mainProjectContractList.vue"], resolve, rejectFunc);
      }
    },  
    //保理个人单笔业务合同列表
    {
      path: "/singlebusiness",
      name: "singlebusiness",
      component: function(resolve) {
        require(["../page/singlebusiness/index.vue"], resolve, rejectFunc);
      }
    },  
    //确认消息
    {
      path: "/ConfirmationInfo",
      name: "ConfirmationInfo",
      component: function(resolve) {
        require(["../page/ConfirmationInfo.vue"], resolve, rejectFunc);
      }
    },
    //测试页面
    {
      path: "/testPage",
      name: "testPage",
      component: function(resolve) {
        require(["../page/testPage.vue"], resolve, rejectFunc);
      }
    },
    //补充发票页面
    {
      path: "/addInvoice",
      name: "addInvoice",
      component: function(resolve) {
        require(["../page/addInvoice.vue"], resolve, rejectFunc);
      }
    },
     //池保理
     {
      path: "/loanDetail_bl_pool",
      name: "loanDetail_bl_pool",
      component: function(resolve) {
        require(["../page/loanDetail_bl_pool.vue"], resolve, rejectFunc);
      }
    }         
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js